/* eslint-disable react-hooks/exhaustive-deps */
import { createContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'
import Header from '../Header'
import Footer from '../Footer'
import Home from '../Home'
import ErrorModal from 'components/common/ErrorModal'
import routes from 'consts/routes'
import RejectEnrollmentPage from '../common/RejectEnrollmentPage'
import Enroll from '../Enroll'
import { REJECT_ENROLLMENT_REASONS } from 'consts/flowConsts'
import { Spin } from 'antd'
import { setLocale, getLocale } from 'i18n'
import BrokerTimoutDialog from 'components/dialogs/BrokerTimoutDialog'
import { LAYOUT_TYPE } from 'consts'
import UnauthorizedModal from 'components/common/UnauthorizedModal'

import './App.css'

export const LanguageContext = createContext(null)

const App = () => {
  const locale = useSelector(locale => locale?.locale)
  const isBroker = useSelector(state => state.app.layout === LAYOUT_TYPE.broker)
  const currentLocation = useLocation()
  const [isDoneLoading, setIsDoneLoading] = useState(false)

  // display footer just on home page
  const isEnrollRoute = currentLocation.pathname.includes(routes.ENROLL)
  const isHomeRoute = !isEnrollRoute
  const isSavePlanShouldAppear =
    isEnrollRoute &&
    currentLocation.pathname !== routes.ENROLL_INFO &&
    currentLocation.pathname !== routes.ENROLL_QUALIFICATION &&
    currentLocation.pathname !== routes.ENROLL_NO_ELIGIBLE &&
    currentLocation.pathname !== routes.ENROLL_SUCCESS

  const queryParams = new URLSearchParams(currentLocation.search)

  const [language, changeLanguage] = useState('en')

  useEffect(() => {
    // get local from storage (if there is one) and set it
    setLocale(getLocale() || 'en').then(() => setIsDoneLoading(true))
  }, [])

  // reload app when locale change (updating the context)
  useEffect(() => {
    changeLanguage(locale)
  }, [locale])

  if (!isDoneLoading) {
    return <Spin size='large' className='page-loading' />
  }

  return (
    <LanguageContext.Provider value={{ language, changeLanguage }}>
      <div className='main-layout'>
        <Header isSaveAvailable={isSavePlanShouldAppear} />
        <div className='scroll center'>
          <div className='app-body'>
            <Routes>
              <Route path={routes.ROOT} element={<Home />} />
              <Route
                path={routes.WELCOME_BACK}
                element={
                  <Navigate
                    to={routes.ROOT}
                    state={{
                      applicationId: queryParams.get('application_id'),
                      route: queryParams.get('step')
                    }}
                  />
                }
              />
              <Route
                path={routes.STATE_NOT_ALLOWED}
                element={
                  <RejectEnrollmentPage
                    reason={REJECT_ENROLLMENT_REASONS.NON_VALID_STATE}
                  />
                }
              />
              <Route
                path={routes.ENROLL + '/*'}
                element={
                  <Enroll isSavePlanShouldAppear={isSavePlanShouldAppear} />
                }
              />
            </Routes>
          </div>
          {isHomeRoute && <Footer />}
        </div>
      </div>
      <ErrorModal />
      <UnauthorizedModal />
      {isBroker && <BrokerTimoutDialog />}
    </LanguageContext.Provider>
  )
}

export default App
